import Button from '@rio-cloud/rio-uikit/Button';

type ButtonVariant = 'primary' | 'danger';

interface IBudgetActionButton {
  label: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  bsStyle?: string;
  variant?: ButtonVariant;
}

interface IBudgetActionButtonGroupProps {
  buttons: IBudgetActionButton[];
  className?: string;
}

interface IBudgetActionButtonGroupProps {
  buttons: IBudgetActionButton[];
  className?: string;
  alignRight?: boolean;
}

const BudgetActionButtonGroup = (props: IBudgetActionButtonGroupProps) => {
  const getButtonClasses = (button: IBudgetActionButton) => {
    const baseClasses = 'w-[250px] text-size-16';
    
    if (button.variant === 'danger' || button.bsStyle === 'btn-danger') {
      return `btn btn-danger ${baseClasses} ${button.className || ''}`;
    }
    
    return `btn btn-primary ${baseClasses} ${button.className || ''}`;
  };

  const alignRight = props.alignRight !== false;

  return (
    <div className={`${alignRight ? 'w-full flex flex-row justify-end' : ''} ${props.className || ''}`}>
      <div className="flex flex-row gap-4">
        {props.buttons.map((button, index) => {
          const isDanger = button.variant === 'danger' || button.bsStyle === 'btn-danger';
          
          return isDanger ? (
            <Button
              key={index}
              className={getButtonClasses(button)}
              onClick={button.onClick}
              disabled={button.disabled}
              bsStyle="danger"
              bsSize="sm"
              variant="outline"
            >
              {button.label}
            </Button>
          ) : (
            <Button
              key={index}
              className={getButtonClasses(button)}
              onClick={button.onClick}
              disabled={button.disabled}
              bsStyle="primary"
              bsSize="sm"
            >
              {button.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default BudgetActionButtonGroup;

